export default __webpack_public_path__ + "close-d18b2bc124e5efaa5259f6a8ccfb0069.svg";